module.exports = __webpack_public_path__ + "img/MN.ce2d7030.svg";